import React from "react";
import "./Footer.scss";

function Footer() {
  return (
    <div className="footer">
        <div>Movie App</div>
        <div>©2024, Movie, Inc. or its affiliates</div>
    </div>
  )
}

export default Footer;
